export enum WindowContents {
    moveStatus = 0,
    assignTech = 1,
    viewBuilder = 2,
	receiving = 3,
	bills = 4,
	vendorCredits = 5,
	vendorReturn = 6,
    newReceiving = 7,
    viewDispatch = 8,
    dbViewBuilder = 9,
    chartWidget = 10,
    unAssignTech = 11
}